import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import Loading from "./Loading";

export default function Layout(){
    return (
        <>
            <Suspense fallback={<Loading />}>
                <Outlet />
            </Suspense>
        </>
    )
}